import {http} from '@utils';

export function getGameCategory(name: 'casino' | 'liveCasino') {
  return http.post<any, any[]>('app/homeGames/getGameCategoryV2', {name});
}

// 获取厂商列表
export function getGameProvider(name: 'casino' | 'liveCasino') {
  return http.post<any, any[]>('app/homeGames/getGameProvider', {name});
}
